<!--
 * @Author: your name
 * @Date: 2021-04-22 12:07:25
 * @LastEditTime: 2021-07-30 19:30:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\cityList.vue
-->
<template>
  <div class="receiving">
    <div class="none-data" v-if="cityList.length == 0">
      <img src="../assets/img/city-none.png" alt />
      <div class="none-title">
        <div class="ccc">暂无收货地址</div>
        <div>快去添加收货地址，买买买吧～</div>
      </div>
    </div>
    <div class="ciltylist" v-else>
      <van-list
        v-model="loading"
        :error.sync="error"
        :finished="finished"
        :immediate-check="true"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="receiv-list" v-for="(item,index) in cityList" :key="index">
          <div class="receiv-item flex-b">
            <div class="receiv-sel flex">
              <!-- iconduihao -->
              <span
                v-if="type == 'comfirm'"
                class="iconfont iconweixuanzhong"
                @click="selectFg(item)"
              ></span>
              <div class="n_width">
                <div class="flex receiv-top">
                  <div class="n_name">{{item.consignee}}</div>
                  <div>{{item.phone}}</div>
                  <div class="moren" v-if="item.is_default == 1">默认</div>
                </div>
                <div
                  class="receiv-city"
                >{{item.address_detail.level_1_name + item.address_detail.level_2_name + item.address_detail.level_3_name + item.address_detail.level_4_name}}{{item.address}}</div>
              </div>
            </div>
            <div>
              <span class="iconfont iconshanchu1" @click="deleteCityFg(item.id)"></span>
              <span class="iconfont iconbianji5" @click="jump(item.id)"></span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="add-receiv" @click="jump('')">新增收货地址</div>
  </div>
</template>
<script>
document.body.style.backgroundColor = '#F7F8FA'
import Vue from 'vue'
import { Toast, Dialog } from 'vant'
import http from '../../http.js'
Vue.use(Toast)
export default {
  name: '',
  data() {
    return {
      cityList: [], //地址列表
      loading: false,
      finished: false,
      error: false,
      page: 1,
      type: '',
    }
  },
  created() {
    console.log(this.$route.query)
    this.type = this.$route.query.type
    this.getCityList()
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    onLoad() {
      console.log('111')
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.page++
      this.getCityList()
    },
    resetFg() {
      this.page = 1
      this.cityList = []
    },
    //获取地址
    async getCityList() {
      let res = await http('ClientAddress.index', {
        page: this.page,
        limit: 10,
      })
      this.cityList = this.cityList.concat(res.content.list)
      this.loading = false
      this.finished = res.content.count == this.cityList.length
    },
    //删除地址 823.03
    deleteCityFg(id) {
      Dialog.confirm({ title: '提示', message: '是否删除该地址' })
        .then((res) => {
          http('ClientAddress.deleteAddress', {
            address_id: id,
          }).then((e) => {
            if (e.status == 200) {
              Toast.success('删除成功')
              this.resetFg()
              this.getCityList()
            } else {
              Toast.success(e.msg)
            }
          })
        })
        .catch((e) => {
          console.log('取消')
        })
    },
    //跳转
    jump(e) {
      this.$router.push({ path: './addCity', query: { id: e } })
    },
    selectFg(item) {
      console.log(item)
      this.$router.replace({
        path: './ConfirmOrder',
        query: {
          encodeData: JSON.stringify(item),
        },
      })
    },
  },
}
</script>
<style scoped>
.receiv-list .receiv-item:last-child {
  border-bottom: none !important;
}
.ciltylist {
  margin-top: 20px;
}
</style>
<style lang="scss" scoped>
.n_width {
  width: 500px;
}
.iconshanchu1 {
  font-size: 36px;
  color: #969799;
  margin-right: 50px;
}
.iconbianji5 {
  font-size: 30px;
}
.iconduihao {
  margin-left: 0;
  font-size: 32px;
  color: #f0240e;
  // margin-right: 28px;
}
.iconweixuanzhong {
  margin-left: 0;
  font-size: 32px;
  margin-right: 28px;
}
.receiv-sel {
  box-sizing: border-box;
  align-items: center;
}
.receiving {
  width: 100%;
  min-height: 100vh;
  background: #f8f8f8;
  .receiv-list {
    display: block;
    background: #ffffff;
    width: 100%;
    .receiv-item {
      margin: 0 auto;
      box-sizing: border-box;
      padding: 24px 0 28px 0;
      width: 686px;
      border-bottom: 1px solid #ebedf0;
      align-items: center;
      .receiv-top {
        font-size: 28px;
        font-weight: 500;
        color: #323233;
        line-height: 40px;
        > div {
          margin-right: 32px;
        }
        .n_name {
          max-width: 170px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .moren {
          padding: 0 15px;
          background: #f0240e;
          border-radius: 20px;
          text-align: center;
          font-size: 18px;
          font-weight: 500;
          color: #ffffff;
          height: 38px;
          line-height: 38px;
        }
      }
      .receiv-city {
        display: block;
        width: 450px;
        font-size: 24px;
        font-weight: 400;
        color: #969799;
        line-height: 32px;
        margin-top: 16px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .add-receiv {
    width: 686px;
    height: 96px;
    display: block;
    background: #ee0a24;
    border-radius: 48px;
    text-align: center;
    font-size: 32px;
    font-weight: 400;
    color: #ffffff;
    line-height: 96px;
    margin: 120px auto;
  }
  .none-data {
    overflow: hidden;
    img {
      width: 320px;
      height: 320px;
      margin: 240px auto 0;
    }
    .none-title {
      text-align: center;
      > div {
        font-size: 28px;
        font-weight: 500;
        color: #969799;
        line-height: 28px;
      }
      > .ccc {
        color: #666666;
        margin-top: 40px;
        margin-bottom: 32px;
      }
    }
  }
}
</style>